import React, { useState, useEffect } from 'react';
import { ArrowUp, MessageCircle, Share2, X, Facebook, Twitter, Linkedin, Link2 ,Instagram} from 'lucide-react';
import { useSelector } from 'react-redux';
import { FaWhatsapp, FaYoutube } from 'react-icons/fa';

function FloatingButtons({whatsapp}) {
    const [showScrollTop, setShowScrollTop] = useState(false);
    const [showShareMenu, setShowShareMenu] = useState(false);
    const [copied, setCopied] = useState(false);

    const whatsappNumber = whatsapp; 
    const whatsappMessage = 'Hello! I would like to know more about ACTADCD Mumbai.';

    useEffect(() => {
        const handleScroll = () => {
            setShowScrollTop(window.scrollY > 300);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    const openWhatsApp = () => {
        const url = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`;
        window.open(url, '_blank');
    };

    const toggleShareMenu = () => {
        setShowShareMenu(!showShareMenu);
    };

      const setting = useSelector((state) => state?.globalState?.siteSetting?.site_settings);
        const shareOptions = [
        { icon: <Facebook size={20} />, action: setting?.facebook, name: 'Facebook',  color: 'from-blue-600 to-blue-700' },
        { icon: <Instagram size={20} />, action: setting?.instagram, name: 'Instagram' ,color: 'from-red-500 to-red-600'},

    ];


    return (
        <>
            {/* Fixed Action Buttons Container */}
            <div className="fixed bottom-6 right-6 z-50 flex flex-col gap-3">
                
                {/* Share Menu */}
                    <div className="flex flex-col gap-2  animate-fadeIn">
                        {shareOptions.map((option, index) => (
                            <a
                                key={option.name}
                                href={option.action}
                                className={`group relative w-12 h-12 bg-gradient-to-r ${option.color} text-white rounded-full shadow-lg hover:shadow-xl transform hover:scale-110 transition-all duration-300 flex items-center justify-center`}
                                style={{
                                    animation: `slideUp 0.3s ease-out ${index * 0.1}s both`
                                }}
                                target='_blank'
                                aria-label={option.name}
                            >
                                {option.icon}
                                <span className="absolute right-14 bg-gray-900 text-white text-xs px-3 py-1.5 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
                                    {option.name}
                                </span>
                            </a>
                        ))}
                    </div>
               

                {/* Copied Toast */}
                {copied && (
                    <div className="absolute bottom-20 right-0 bg-green-500 text-white text-sm px-4 py-2 rounded-lg shadow-lg animate-fadeIn">
                        Link Copied!
                    </div>
                )}

                {/* <button
                    onClick={toggleShareMenu}
                    className={`w-14 h-14 bg-gradient-to-r ${showShareMenu ? 'from-red-500 to-red-600' : 'from-purple-500 to-pink-500'} text-white rounded-full shadow-xl hover:shadow-2xl transform hover:scale-110 transition-all duration-300 flex items-center justify-center group`}
                    aria-label="Share"
                >
                    {showShareMenu ? (
                        <X size={24} className="group-hover:rotate-90 transition-transform duration-300" />
                    ) : (
                        <Share2 size={24} className="group-hover:rotate-12 transition-transform duration-300" />
                    )}
                </button> */}

                {/* WhatsApp Button */}
                <button
                    onClick={openWhatsApp}
                    className="w-12 h-12 bg-gradient-to-r from-green-500 to-green-600 text-white rounded-full shadow-xl hover:shadow-2xl transform hover:scale-110 transition-all duration-300 flex items-center justify-center group relative"
                    aria-label="WhatsApp"
                >
                    <FaWhatsapp  size={24} className="group-hover:scale-110 transition-transform duration-300" />
                    <span className="absolute -top-1 -right-1 w-3 h-3 bg-red-500 rounded-full animate-ping"></span>
                    <span className="absolute -top-1 -right-1 w-3 h-3 bg-red-500 rounded-full"></span>
                </button>

                {showScrollTop && (
                    <button
                        onClick={scrollToTop}
                        className="w-14 h-14 bg-gradient-to-r from-red-500 to-yellow-500 text-white rounded-full shadow-xl hover:shadow-2xl transform hover:scale-110 transition-all duration-300 flex items-center justify-center group animate-slideUp"
                        aria-label="Scroll to top"
                    >
                        <ArrowUp size={24} className="group-hover:-translate-y-1 transition-transform duration-300" />
                    </button>
                )}
            </div>

            {/* Custom Animations */}
            <style jsx>{`
                @keyframes slideUp {
                    from {
                        opacity: 0;
                        transform: translateY(20px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }

                @keyframes fadeIn {
                    from {
                        opacity: 0;
                    }
                    to {
                        opacity: 1;
                    }
                }

                .animate-slideUp {
                    animation: slideUp 0.3s ease-out;
                }

                .animate-fadeIn {
                    animation: fadeIn 0.3s ease-out;
                }
            `}</style>
        </>
    );
}

export default FloatingButtons;